module.exports = __webpack_public_path__ + "img/4368e7a.png";